'use client';

import { c as _c } from "react/compiler-runtime";
import { FileUpload, FlexContainer } from '@/shared/ui';
import { Tabs, TabsContent } from '@ncai-axe/react-ui-v3';
import { useTranslations } from 'next-intl';
import { IMAGE_MIME_TYPES } from '../../model/config';
import { QRCode } from './QRCode';
type Props = {
  caption?: string;
  mimeTypes?: string[];
  onChange: (files: File[]) => void;
};
export default function UploadTab(t0) {
  const $ = _c(25);
  const {
    caption: t1,
    mimeTypes,
    onChange
  } = t0;
  const caption = t1 === undefined ? "" : t1;
  const t = useTranslations("imageUpload");
  const tImages = useTranslations("images");
  let t2;
  if ($[0] !== tImages) {
    t2 = tImages("prompt.upload.localUpload");
    $[0] = tImages;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = {
      children: t2,
      value: "localUpload"
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("tabs.qrUpload");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = {
      children: t4,
      value: "qrUpload",
      disabled: true
    };
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = [t3, t5];
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const triggers = t6;
  let t7;
  if ($[11] !== onChange) {
    t7 = files => {
      onChange(Array.from(files));
    };
    $[11] = onChange;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const handleChange = t7;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      width: "100%"
    };
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== mimeTypes) {
    t9 = mimeTypes?.join(",") || IMAGE_MIME_TYPES.join(",");
    $[14] = mimeTypes;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      width: "100%"
    };
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== caption || $[18] !== handleChange || $[19] !== t9) {
    t11 = <TabsContent value="localUpload"><FlexContainer height="103px"><FileUpload accept={t9} caption={caption} style={t10} onFilesSelected={handleChange} /></FlexContainer></TabsContent>;
    $[17] = caption;
    $[18] = handleChange;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <TabsContent value="qrUpload"><FlexContainer height="103px"><QRCode value="" /></FlexContainer></TabsContent>;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== triggers) {
    t13 = <Tabs defaultValue="localUpload" triggers={triggers} ariaLabel="Upload Tab" style={t8}>{t11}{t12}</Tabs>;
    $[22] = t11;
    $[23] = triggers;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
}